import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  inputSelectForm: {
    width: '100%',
    border: `1px solid ${theme.colors['grey-100']}`,
    backgroundColor: theme.colors.white,
    borderRadius: 4,
    height: 48,
    '&:hover': {
      backgroundColor: theme.colors['primary-lighter'],
    },
  },
  tagsSelect: {
    height: '100%',
    color: theme.colors.primary,
    padding: 15,
    lineHeight: 'normal',
    flex: 1,
  },
  tagsSelectValues: {
    width: 'auto !important',
    position: 'absolute',
    bottom: '-1px',
    transform: 'translateY(100%)',
    left: '0',
    right: '0',
    zIndex: '100',
  },
  tagsSelectListContainer: {
    overflow: 'auto',
    maxHeight: '340px',
  },
}))
